import React from 'react';
import { motion } from 'framer-motion';
import { images } from '../../utils/imagePaths';
import "../../styles/about.css"
import "../../styles/section.css"

const About = () => {
  return (
    <section className="about" id="about">
      <div className="container">
        <div className="wrapper">
          <div className="about-img-space">
            <motion.div
              className="about-img"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <img className="img-fluid" src={images.aboutUs} alt="About us" />
            </motion.div>
            <motion.div
              className="highlighter"
              initial={{ opacity: 0, scale: 0.5 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <h3>26</h3>
              <h4>Years of Experience</h4>
            </motion.div>
          </div>
          <motion.div
            className="about-details"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <h2 className="section-title">About Us</h2>
            <h3 className="section-head">We build software solutions that solve our clients problems</h3>
            <p className="justified-text">
              XQlusive Solutions (powered by Sarang Software Solutions) is peopled by young, energetic, curious and committed minds
              who are excited about delivering futuristic digital solutions for solving complex
              business problems Ethically & Technically!! We are good at it. Conceived with a
              vision to leave a legacy of transformed peoples as an organization, we place a
              high emphasis on working in cognizance of our Client's business goals.
            </p>

          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;